import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'digits',
    standalone: true
})
export class DigitsPipe implements PipeTransform {
    transform(value: unknown, ...args: unknown[]): unknown {
        const n = Number(value);
        const digits = args[0] ? Number(args[0]) : 2;
        return n.toFixed(2);
    }
}